import { render, staticRenderFns } from "./iapptypes.vue?vue&type=template&id=b408f724&"
import script from "./iapptypes.vue?vue&type=script&lang=js&"
export * from "./iapptypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports